import type { BrowseContext, BrowseContextArgs } from './types';

const getBrowseContext = ({
  baseUrl = '',
  jhaToken,
}: BrowseContextArgs): BrowseContext => ({
  baseUrl,
  providerData: {
    previousProvider: 'gdt-localtest',
    previousPrice: 100,
    previousCurrency: 'GBP',
  },
  ...(jhaToken && { jhaToken }),
});

export default getBrowseContext;
